module.exports = __webpack_public_path__ + "img/devices-mockup.dc781e1a.png";